<template>
	<div id="data-list-list-view" class="data-list-container">
		<vs-table
			v-if="statusReadPermission"
			ref="table"
			pagination
			search
			:max-items="itemsPerPage"
			:data="listStatus"
		>
			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
				<vs-button
					v-if="statusCreatePermission"
					type="filled"
					class="g-btn-customize p-0 btnCustom"
					icon-pack="feather"
					icon="icon-plus"
					@click.prevent="openPopup()"
				>
					<span class="btnTextCustom" v-text="$t('StatusModule.Create')"></span>
				</vs-button>
			</div>
			<template slot="thead">
				<vs-th class="g-table--title" sort-key="name" v-text="$t('StatusModule.ColumnsName.Name')"></vs-th>
				<vs-th class="g-table--title" sort-key="added" v-text="$t('StatusModule.ColumnsName.Added')"></vs-th>
				<vs-th
					v-if="statusUpdatePermission || statusDeletePermission"
					class="g-table--title"
					v-text="$t('Action')"
				></vs-th>
			</template>
			<template slot-scope="{data}">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							<p class="g-table--description truncate">
								{{ tr.name }}
							</p>
						</vs-td>
						<vs-td>
							<p class="g-table--description truncate">
								{{ tr.added_on }}
							</p>
						</vs-td>
						<vs-td
							class="g-table--description whitespace-no-wrap"
							v-if="statusUpdatePermission || statusDeletePermission"
						>
							<feather-icon
								v-if="statusUpdatePermission"
								icon="Edit2Icon"
								svgClasses="w-5 h-5 hover:text-primary stroke-current"
								class="g-label--normal"
								@click.stop="openPopup(tr)"
							/>

							<feather-icon
								v-if="statusDeletePermission"
								icon="Trash2Icon"
								svgClasses="w-5 h-5 hover:text-danger stroke-current"
								class="ml-2 g-label--normal"
								@click.stop="openConfirm(tr)"
							/>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<!-- PopUp -->
		<vs-popup :title="titlePopUp" :active.sync="popupActive">
			<label class="g-label--normal" v-text="$t('StatusModule.PopupEdit.LabelInput')"></label>
			<vs-input
				class="w-full mb-3"
				v-model="itemSelected.name"
				name="name"
				v-validate="{required: true, regex: /^[A-Za-z_\s]+$/}"
			/>
			<span
				class="text-danger text-sm"
				v-show="errors.has('name')"
				v-text="$t('StatusModule.ValidMessages.ValidName')"
			></span>
			<vs-button
				class="float-right g-btn--resourcePopup"
				color="success"
				type="filled"
				:disabled="isFormValid"
				@click="confirmPopUp()"
				>{{ buttonPopUp }}
			</vs-button>
		</vs-popup>
	</div>
</template>

<script>
//Modulo import
import moduleStatus from "@/store/status/moduleStatus.js";
import Status from "@/models/Status.js";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	name: "StatusChield",
	components: {
		NotPermission,
	},
	data() {
		return {
			itemsPerPage: 10,
			isMounted: false,
			itemSelected: new Status({}),
			popupActive: false,
			editable: false,
			statusReadPermission: false,
		};
	},
	computed: {
		// Modifica el titulo del PopUp
		titlePopUp() {
			return this.editable == true
				? this.$t("StatusModule.PopupEdit.LabelTittle")
				: this.$t("StatusModule.PopupCreate.LabelTittle");
		},
		// Modifica el texto del boton del PopUp
		buttonPopUp() {
			return this.editable == true
				? this.$t("StatusModule.PopupEdit.LabelButton")
				: this.$t("StatusModule.PopupCreate.LabelButton");
		},
		isFormValid() {
			return this.errors.any();
		},
		// Pagina actual
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		// Retona la lista de status del state
		listStatus() {
			return this.$store.state.moduleStatus.status;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.listStatus.length;
		},
		statusCreatePermission() {
			return this.$store.getters.checkPermission("STATUS_C");
		},
		statusReadComputed: {
			get() {
				return this.statusReadPermission;
			},
			set(val) {
				this.statusReadPermission = val;
			},
		},
		statusUpdatePermission() {
			return this.$store.getters.checkPermission("STATUS_U");
		},
		statusDeletePermission() {
			return this.$store.getters.checkPermission("STATUS_D");
		},
	},
	methods: {
		// Se abre el popUp
		openPopup(data) {
			// Se reinician las validaciones
			this.$validator.reset();
			// Se se le envian parametros esta editando
			if (data) {
				this.itemSelected = {...data};
				this.editable = true;
			} else {
				this.itemSelected = new Status({});
				this.editable = false;
			}
			this.popupActive = true;
		},
		// Confirma el popUp editando o creando
		confirmPopUp() {
			// Valida los errores
			this.$validator.validateAll().then((result) => {
				if (!result) {
					// Valida los campos para poder visualizar los mensaje de error
					this.$validator.validate();
				} else {
					// Se genera el objeto a enviar
					let objectFinal;
					objectFinal = {};
					objectFinal.name = this.itemSelected.name;
					if (!this.editable) {
						// Esta creando, entonces solo se envia el nombre
						this.createData(objectFinal);
					} else {
						// Si esta editando se necesita conocer el id del estado para la url del servicio
						objectFinal.id = this.itemSelected.id;
						this.editData(objectFinal);
					}
				}
			});
		},
		createData(object) {
			// Identifica el action en el Vuex
			this.$store
				.dispatch("moduleStatus/addStatus", object)
				.then((res) => {
					// Respuesta exitosa
					// cierra el load
					this.closeLoading();
					// Cerrar popUp
					this.popupActive = false;
					// Reinicia las validaciones de entrada
					this.$validator.reset();
					// Muestra mensaje de exito
					this.$vs.notify({
						color: "success",
						title: this.$t("StatusModule.ResponseCreate.Title"),
						text: this.$t("StatusModule.ResponseCreate.Text"),
					});
				})
				.catch((err) => {
					// Respuesta erronea
					// Cierra load
					this.closeLoading();
					// Muestra mensaje de error
					this.$vs.notify({
						color: "danger",
						title: this.$t("StatusModule.ResponseCreate.TitleError"),
						text: this.$t("StatusModule.ResponseCreate.TextError"),
					});
					throw new Error(err);
				});
		},
		editData(object) {
			// Identifica el action en el Vuex
			this.$store
				.dispatch("moduleStatus/updateStatus", object)
				.then((res) => {
					// Respuesta exitosa
					// cierra el load
					this.closeLoading();
					// Cerrar popUp
					this.popupActive = false;
					// Reinicia las validaciones de entrada
					this.$validator.reset();
					// Muestra mensaje de exito
					this.$vs.notify({
						color: "success",
						title: this.$t("StatusModule.ResponseEdit.Title"),
						text: this.$t("StatusModule.ResponseEdit.Text"),
					});
				})
				.catch((err) => {
					// Respuesta erronea
					// Cierra load
					this.closeLoading();
					// Muestra mensaje de error
					this.$vs.notify({
						color: "danger",
						title: this.$t("StatusModule.ResponseEdit.TitleError"),
						text: this.$t("StatusModule.ResponseEdit.TextError"),
					});
					throw new Error(err);
				});
		},
		// Click boton eliminar
		openConfirm(data) {
			this.itemSelected = data;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("StatusModule.PopupDelete.LabelText"),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
				accept: this.acceptAlert,
			});
		},
		// Se acepta la eliminación
		acceptAlert() {
			this.deleteData(this.itemSelected.id);
		},
		deleteData(id) {
			this.$store
				.dispatch("moduleStatus/removeStatus", id)
				.then((res) => {
					// Respuesta exitosa
					// cierra el load
					this.closeLoading();
					// Muestra mensaje de exito
					this.$vs.notify({
						color: "success",
						title: this.$t("StatusModule.ResponseDelete.Title"),
						text: this.$t("StatusModule.ResponseDelete.Text"),
					});
				})
				.catch((err) => {
					// Respuesta erronea
					// Cierra load
					this.closeLoading();
					// Muestra mensaje de error
					this.$vs.notify({
						color: "danger",
						title: this.$t("StatusModule.ResponseDelete.TitleError"),
						text: this.$t("StatusModule.ResponseDelete.TextError"),
					});
					throw new Error(err);
				});
		},
		// Consulta los status
		consultStatus() {
			this.loading();
			this.$store
				.dispatch("moduleStatus/getStatus")
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					this.$vs.notify({
						color: "danger",
						title: this.$t("StatusModule.GetStatus.TitleError"),
						text: this.$t("StatusModule.GetStatus.TextError"),
					});
					throw new Error(err);
				});
		},
		// Inicia el load
		loading() {
			this.$vs.loading();
		},
		// Cierra el load
		closeLoading() {
			this.$vs.loading.close();
		},
		async getPermissions() {
			const user = await this.userSession.getUser();
		},
	},
	mounted() {
		// importante para el metodo currentPage
		this.isMounted = true;
	},
	created() {
		// Registrar modulo
		if (!moduleStatus.isRegistered) {
			this.$store.registerModule("moduleStatus", moduleStatus);
			moduleStatus.isRegistered = true;
		}
		// Consultar status
		this.consultStatus();
		setTimeout(() => {
			this.statusReadComputed = this.$store.getters.checkPermission("STATUS_R");
		}, 100);
	},
};
</script>

<style lang="scss" scoped>
// Transforma el texto en los input en mayusculas
div input {
	text-transform: uppercase;
}

#data-list-list-view {
	.vs-con-table {
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;

			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			padding: 0 1rem;

			td {
				font-style: normal;
				font-weight: 300;
				font-size: 12px;
				line-height: 15px;
				color: #666666;
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;
			}

			th.td-check {
				padding: 0 15px !important;
			}

			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
